import {JsonProperty} from 'json-typescript-mapper';
import {Salesunit} from './salesunit.model';
import {Contract} from './contract.model';
import {Contact, ContactSimplified} from './contact.model';
import {GeoEntity} from './geo-entity.model';
import { SalesunitTemp } from './salesunit-temp.model';

export enum MarketAccountingEntryType {
  Booth = <any>'Booth',
  Expense = <any>'Expense',
  Total = <any>'Total',
};

export enum SqmAdditionalType {
  Null = <any>'Null',
  HighTable = <any>'HighTable',
  ProductCarriers = <any>'ProductCarriers',
  CoatRack = <any>'CoatRack',
  FloorArea = <any>'FloorArea',
  OtherAarea = <any>'OtherAarea'
}

export class BackofficeMarketAccountingEntry {
  @JsonProperty('marketdateBoothId')
  public marketdateBoothId?: number;

  @JsonProperty('status')
  public status?: string;

  @JsonProperty('contractType')
  public contractType?: string;

  @JsonProperty('contract')
  public contract?: Contract;

  @JsonProperty('companyName')
  public companyName?: string;

  @JsonProperty('companyAdditional')
  public companyAdditional?: string;

  @JsonProperty('merchantName')
  public merchantName?: string;

  @JsonProperty('merchantNumber')
  public merchantNumber?: string;

  @JsonProperty('merchantId')
  public merchantId?: number;

  @JsonProperty('merchant')
  public merchant?: Contact;

  @JsonProperty('salesunit')
  public salesunit?: Salesunit;

  @JsonProperty('salesunitAssortment')
  public salesunitAssortment?: string;

  @JsonProperty('salesunitContact')
  public salesunitContact?: Contact;

  @JsonProperty('salesunitIdentification')
  public salesunitIdentification?: string;

  @JsonProperty('salesunitNumber')
  public salesunitNumber?: string;

  @JsonProperty('salesunitType')
  public salesunitType?: string;

  @JsonProperty('width')
  public width?: number;

  @JsonProperty('depth')
  public depth?: number;

  @JsonProperty('widthAdditional')
  public widthAdditional?: number;

  @JsonProperty('depthAdditional')
  public depthAdditional?: number;

  @JsonProperty('widthAdditionalDaily')
  public widthAdditionalDaily?: number;

  @JsonProperty('depthAdditionalDaily')
  public depthAdditionalDaily?: number;

  @JsonProperty('sqmCost')
  public sqmCost?: number;

  @JsonProperty('sqmCostIncludingBase')
  public sqmCostIncludingBase?: number;

  @JsonProperty('sqmCostIncludingAdditionalFeeCash')
  public sqmCostIncludingAdditionalFeeCash?: number;

  @JsonProperty('sqmAdditionalType')
  public sqmAdditionalType?: SqmAdditionalType;

  @JsonProperty('energyPriceType')
  public energyPriceType?: string;

  @JsonProperty('energyPriceTypeDivergent')
  public energyPriceTypeDivergent?: string;

  @JsonProperty('energyPrice')
  public energyPrice?: number;

  @JsonProperty('priceSanitary')
  public priceSanitary?: number;

  @JsonProperty('priceCleaning')
  public priceCleaning?: number;

  @JsonProperty('priceParking')
  public priceParking?: number;

  @JsonProperty('priceVariable')
  public priceVariable?: number;

  @JsonProperty('marketingFee')
  public marketingFee?: number;

  @JsonProperty('priceTotal')
  public priceTotal?: number;

  @JsonProperty('pricePerUnit')
  public pricePerUnit?: number;

  @JsonProperty('priceCategory')
  public priceCategory?: string;

  @JsonProperty('noPaymentReceived')
  public noPaymentReceived?: boolean;

  @JsonProperty('noPaymentReceivedReason')
  public noPaymentReceivedReason?: string;

  @JsonProperty('partialPaymentReceived')
  public partialPaymentReceived?: boolean;

  @JsonProperty('partialPayment')
  public partialPayment?: number;

  @JsonProperty('paidAmount')
  public paidAmount?: number;

  @JsonProperty('updatedBy')
  public updatedBy?: string;

  @JsonProperty('updatedByContactId')
  public updatedByContactId?: number;

  @JsonProperty('updatedByContactSimplified')
  public updatedByContactSimplified?: ContactSimplified;

  @JsonProperty('updatedAt')
  public updatedAt?: string;

  @JsonProperty('absentMessage')
  public absentMessage?: string;

  @JsonProperty('noSign')
  public noSign?: boolean;

  @JsonProperty('signIssueDate')
  public signIssueDate?: string;

  @JsonProperty('openPaymentSettled')
  public openPaymentSettled?: number;

  @JsonProperty('lastAccount')
  public lastAccount?: string;

  @JsonProperty({clazz: Contact, name: 'lastAccountContactPerson'})
  public lastAccountContactPerson?: Contact;

  @JsonProperty('lastStatus')
  public lastStatus?: string;

  @JsonProperty({clazz: GeoEntity, name: 'geoEntity'})
  public geoEntity?: GeoEntity;

  @JsonProperty('permanentMarketingFee')
  public permanentMarketingFee?: number;

  @JsonProperty('discount')
  public discount?: number;

  @JsonProperty('discountPercentage')
  public discountPercentage?: number;

  @JsonProperty('discountType')
  public discountType?: string;

  @JsonProperty('suBoothWidth')
  public suBoothWidth?: number;

  @JsonProperty('suBoothWidthWinter')
  public suBoothWidthWinter?: number;

  @JsonProperty('suBoothDepth')
  public suBoothDepth?: number;

  @JsonProperty('suBoothDepthWinter')
  public suBoothDepthWinter?: number;

  @JsonProperty('suEnergyType')
  public suEnergyType?: string;

  @JsonProperty('suEnergyTypeWinter')
  public suEnergyTypeWinter?: string;

  @JsonProperty('suEnergyPrice')
  public suEnergyPrice?: number;

  @JsonProperty('suAssortment')
  public suAssortment?: string;

  @JsonProperty('suAssortmentAdditional')
  public suAssortmentAdditional?: string;

  @JsonProperty('suAssortmentExtended')
  public suAssortmentExtended?: string;

  @JsonProperty('suAssortmentExtendedAdditional')
  public suAssortmentExtendedAdditional?: string;

  @JsonProperty('suUseWinterSize')
  public suUseWinterSize?: boolean;

  @JsonProperty('cpDisplayname')
  public cpDisplayname?: string;

  @JsonProperty('cpFunction')
  public cpFunction?: string;

  @JsonProperty('cpMobile')
  public cpMobile?: string;

  @JsonProperty('meNumber')
  public meNumber?: string;

  @JsonProperty('meCompany')
  public meCompany?: string;

  @JsonProperty('meCompanyAdditional')
  public meCompanyAdditional?: string;

  @JsonProperty('ctBoothWidth')
  public ctBoothWidth?: number;

  @JsonProperty('ctBoothWidthWinter')
  public ctBoothWidthWinter?: number;

  @JsonProperty('ctBoothWidthAdditional')
  public ctBoothWidthAdditional?: number;

  @JsonProperty('ctBoothWidthWinterAdditional')
  public ctBoothWidthWinterAdditional?: number;

  @JsonProperty('ctBoothDepth')
  public ctBoothDepth?: number;

  @JsonProperty('ctBoothDepthWinter')
  public ctBoothDepthWinter?: number;

  @JsonProperty('ctBoothDepthAdditional')
  public ctBoothDepthAdditional?: number;

  @JsonProperty('ctBoothDepthWinterAdditional')
  public ctBoothDepthWinterAdditional?: number;

  @JsonProperty('ctEnergyType')
  public ctEnergyType?: string;

  @JsonProperty('ctEnergyTypeWinter')
  public ctEnergyTypeWinter?: string;

  @JsonProperty('ctUseWinterSize')
  public ctUseWinterSize?: boolean;

  @JsonProperty('ctUseAddtitionalWinterSize')
  public ctUseAddtitionalWinterSize?: boolean;

  @JsonProperty('ctSalesunitNumber')
  public ctSalesunitNumber?: string;

  @JsonProperty('ctSalesunitIdentification')
  public ctSalesunitIdentification?: string;

  @JsonProperty('salesunitBefore')
  public salesunitBefore?: SalesunitTemp;

  @JsonProperty('tempAreaChange')
  public tempAreaChange?: boolean;

  @JsonProperty('openPayment')
  public openPayment?: number;

  @JsonProperty('marketwebsiteBaseFee')
  public marketwebsiteBaseFee?: number;

  @JsonProperty('marketwebsiteAdvertisingFee')
  public marketwebsiteAdvertisingFee?: number;

  @JsonProperty('postalReceiptFee')
  public postalReceiptFee?: number = void 0;

  constructor() {
    this.marketdateBoothId = void 0;
    this.status = void 0;
    this.contractType = void 0;
    this.contract = void 0;
    this.companyName = void 0;
    this.companyAdditional = void 0;
    this.merchantName = void 0;
    this.merchantNumber = void 0;
    this.merchantId = void 0;
    this.merchant = void 0;

    this.salesunit = void 0;
    this.salesunitAssortment = void 0;
    this.salesunitContact = void 0;
    this.salesunitIdentification = void 0;
    this.salesunitNumber = void 0;
    this.salesunitType = void 0;

    this.width = 0;
    this.depth = 0;
    this.widthAdditional = 0;
    this.depthAdditional = 0;
    this.widthAdditionalDaily = 0;
    this.depthAdditionalDaily = 0;

    this.sqmCost = 0;
    this.sqmCostIncludingBase = 0;
    this.sqmCostIncludingAdditionalFeeCash = 0;
    this.sqmAdditionalType = void 0;

    this.energyPriceType = void 0;
    this.energyPriceTypeDivergent = void 0;
    this.energyPrice = 0;

    this.priceSanitary = 0;
    this.priceCleaning = 0;
    this.priceParking = 0;
    this.priceVariable = 0;

    this.marketingFee = 0;
    this.priceTotal = 0;

    this.noPaymentReceived = false;
    this.noPaymentReceivedReason = void 0;
    this.partialPaymentReceived = false;
    this.partialPayment = 0;

    this.paidAmount = 0;

    this.updatedBy = void 0;
    this.updatedByContactId = 0;
    this.updatedByContactSimplified = void 0;
    this.updatedAt = void 0;

    this.absentMessage = void 0;

    this.noSign = void 0;
    this.signIssueDate = void 0;

    this.openPaymentSettled = void 0;

    this.lastAccount = void 0;
    this.lastAccountContactPerson = void 0;
    this.lastStatus = void 0;

    this.geoEntity = void 0;

    this.permanentMarketingFee = void 0;

    this.discount = void 0;
    this.discountPercentage = void 0;
    this.discountType = void 0;

    this.suBoothWidth = void 0;
    this.suBoothWidthWinter = void 0;
    this.suBoothDepth = void 0;
    this.suBoothDepthWinter = void 0;
    this.suEnergyType = void 0;
    this.suEnergyTypeWinter = void 0;
    this.suEnergyPrice = void 0;
    this.suAssortment = void 0;
    this.suAssortmentAdditional = void 0;
    this.suAssortmentExtended = void 0;
    this.suAssortmentExtendedAdditional = void 0;
    this.suUseWinterSize = void 0;
    this.cpDisplayname = void 0;
    this.cpFunction = void 0;
    this.cpMobile = void 0;
    this.meNumber = void 0;
    this.meCompany = void 0;
    this.meCompanyAdditional = void 0;
    this.ctBoothWidth = void 0;
    this.ctBoothWidthWinter = void 0;
    this.ctBoothWidthAdditional = void 0;
    this.ctBoothWidthWinterAdditional = void 0;
    this.ctBoothDepth = void 0;
    this.ctBoothDepthWinter = void 0;
    this.ctBoothDepthAdditional = void 0;
    this.ctBoothDepthWinterAdditional = void 0;
    this.ctEnergyType = void 0;
    this.ctEnergyTypeWinter = void 0;
    this.ctUseWinterSize = void 0;
    this.ctUseAddtitionalWinterSize = void 0;
    this.ctSalesunitNumber = void 0;
    this.ctSalesunitIdentification = void 0;

    this.salesunitBefore = void 0;

    this.pricePerUnit = void 0;
    this.priceCategory = void 0;

    this.openPayment = void 0;
    this.tempAreaChange = void 0;

    this.marketwebsiteBaseFee = void 0;
    this.marketwebsiteAdvertisingFee = void 0;
  }
}




// WEBPACK FOOTER //
// ./src/app/entities/backoffice-market-accounting-entry.model.ts